// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useSelector } from "react-redux";

const useClientId = (options?: Toolkit.GoogleAnalytics.Options) => {
    return useSelector((state: ApplicationState) => state.context.session.userProfileId || undefined);
};

export default useClientId;
